import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as _ from 'underscore';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  miniCartPopup = false;
  public emailConsent = new Subject<any>();
  emailConsent$ = this.emailConsent.asObservable();
  reserveNowPopup = false;
  modelContent: ElementRef;
  FutureshipModelContent: ElementRef;
  public matNrData = new BehaviorSubject<any>(false); // behaviour subject containing the parent data of invoices & credit
  public snippetData = new Subject<any>();
  snippetData$ = this.snippetData.asObservable();
  constructor(private readonly baseService: BaseService) {
  }

  setSessionStorage(keyName: string, data: any): any {
    sessionStorage.setItem(keyName, JSON.stringify(data));
  }
  getSessionStorage(keyName): any {
    let value;
    if (sessionStorage.getItem(keyName) != 'undefined') {
      value = JSON.parse(sessionStorage.getItem(keyName)); // if undefined, causing syntaxError - "undefined" not a valid json val
    }
    return value; //if its "undefined", then undefined returned, instead of Syntax error
  }
  removeSessionStorage(keyName: string): any {
    sessionStorage.removeItem(keyName);
  }
  // Using Local storage for ASM
  setLocalStorage(keyName: string, data: any): any {
    localStorage.setItem(keyName, JSON.stringify(data));
  }
  getLocalStorage(keyName): any {
    const value = JSON.parse(localStorage.getItem(keyName));
    return value;
  }
  //End
  getEmailConsent(userId) {
    this.baseService.get('/users/' + userId + '/emailconsent?fields=DEFAULT').subscribe((res) => {
      if (res) {
        this.emailConsent.next(res);
      }
    });
  }
  setEmailConsent(userId, emailConsent) {
    this.baseService.post('/users/' + userId + '/emailconsent?' + 'emailConsent=' + emailConsent, {}).subscribe((res) => {
    });
  }
  fileChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      // Size Filter Bytes
      const max_size = 15728640;
      const allowed_types = [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpg',
        'image/jpeg',
        'application/pdf',
        'image/png',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ];
      if (fileInput.target.files[0].size > max_size) {
        return false;
      }
      if (!_.contains(allowed_types, fileInput.target.files[0].type) && !(fileInput.target.files[0].name.substring(fileInput.target.files[0].name.length - 4, fileInput.target.files[0].name.length) === '.msg')) {
        return false;
      }
      const reader = new FileReader();
      reader.readAsDataURL(fileInput.target.files[0]);
      let fileBase64Path: any;
      return Observable.create(observer => {
        reader.onload = (e: any) => {
          let blob = new Blob(fileInput.target.files, { type: fileInput.target.files[0].type });
          let url = window.URL.createObjectURL(blob);
          fileBase64Path = { base64String: e.target.result, fileName: fileInput.target.files[0].name, fileType: fileInput.target.files[0].type, selectedBlobUrl: url };
          observer.next(fileBase64Path);
          observer.complete();
        };
      });
    }
  }

  removeFile(uploadedFilesData, removedData) {
    const index: number = uploadedFilesData.indexOf(removedData);
    if (index !== -1) {
      uploadedFilesData.splice(index, 1);
    }
    return uploadedFilesData;
  }

  fetchProductAllocations(userID, b2bUID): Observable<any> {
    return this.baseService.get('user/' + userID + '/productallocation/' + b2bUID);
  }

  removeLocalStorage(keyName: string): any {
    localStorage.removeItem(keyName);
  }

  // deleteSamlToken(accId): Observable<any>{
  //   return this.baseService.get(`assisted-service/${accId}/endSession`);
  // }
  deleteSamlToken(accId): Observable<any> {
    return this.baseService?.get(`assisted-service/${accId}/endCustomerSession`);
  }
  getsnippetAPI(){
    this.baseService.get('/snippet-config/fetch').subscribe((res) => {
      if (res) {
        this.snippetData.next(res);
      }
    });
  }
}
